export const chartGradientDataUri = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='620' height='382' viewBox='0 0 620 382' fill='none'%3E%3Cellipse opacity='0.4' cx='310' cy='191' rx='310' ry='191' fill='url(%23paint0_radial_1_2865)' fill-opacity='0.2'/%3E%3Cdefs%3E%3CradialGradient id='paint0_radial_1_2865' cx='0' cy='0' r='1' gradientUnits='userSpaceOnUse' gradientTransform='translate(310 191) rotate(90) scale(183.48 298.163)'%3E%3Cstop offset='0.104167' stop-color='%233CCECE' stop-opacity='0.96'/%3E%3Cstop offset='1' stop-color='%23FF00D2' stop-opacity='0'/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E`;

export const chartColors = {
  bgSurface: '#1F1F1F', // background.surface
  fgMuted: '#9E9E9E', // foreground.on-disabled
  axisLine: '#868E9F', // slate.400
  splitLine: '#28303E', // slate.600
  fontFamily: 'PT Mono, monospace',
  colorPalette: [
    //300 primary
    '#F093EE',
    '#9A8CE8',
    '#F2A2B3',

    //200 primary
    '#F3AEF2',
    '#BBB2EF',
    '#F9D0D9',

    //400 primary
    '#E85EE5',
    '#7865E0',
    '#E95C7B',

    //100 primary
    '#F7C9F7',
    '#DDD9F7',
    '#FCE8EC',

    //300 secondary
    '#FFE4AF',
    '#A3DDBC',

    //500 primary
    '#E028DD',

    //200 secondary
    '#868E9F',
    '#D1EEDD',

    //400 secondary
    '#FFCF74',
    '#5DC389',
    '#BDBDBD',

    //500 secondary
    '#FFBB38',
    '#18A957',
  ],
};
